module.exports = __webpack_public_path__ + "img/aidtools_history.461ba3ba.png";